import React, { FC, ReactNode, useEffect } from 'react';

import SuctionWrap from '../../components/SuctionWrap';

import styles from './TimeHonoredFooter.module.scss';

interface Props {
  title: string;
  orderTitle: string[];
  extra?: ReactNode;
}

const TimeHonoredFooter: FC<Props> = (props) => {
  const { title, orderTitle, extra } = props;

  const orderTitleNode = Array.isArray(orderTitle) && orderTitle.length && (
    <div className={styles['time-honored-footer-order-title-container']}>
      {orderTitle.map((item, idx) => (
        <div className={styles['time-honored-footer-order-title-item']} key={idx}>
          {item}
        </div>
      ))}
    </div>
  );

  useEffect(() => {
    let placeholderSuction: HTMLElement;
    if (window) {
      placeholderSuction = document.createElement('div');
      placeholderSuction.className = styles['time-honored-footer-suction-placeholder'];
      document.body.appendChild(placeholderSuction);
    }

    return () => {
      if (placeholderSuction) {
        document.body.removeChild(placeholderSuction);
      }
    };
  }, []);

  return (
    <SuctionWrap>
      <div className={styles['time-honored-footer-wrap']}>
        <div className={styles['time-honored-footer-container']}>
          {title && <div className={styles['time-honored-footer-title']}>{title}</div>}
          {orderTitleNode}
          {extra && <div className={styles['time-honored-footer-extra']}>{extra}</div>}
        </div>
      </div>
    </SuctionWrap>
  );
};

TimeHonoredFooter.displayName = 'TimeHonoredFooter';
TimeHonoredFooter.defaultProps = {
  title: '',
  orderTitle: [],
};

export default TimeHonoredFooter;
